import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DynamicComponentHOC } from "components/DynamicComponentHOC/DynamicComponentHOC";
import { Message } from "components/Message/Message";
import React, { createContext, useEffect, useState } from "react";
import { ComponentParams } from "types/types";
import { ICON_TYPE } from "utils/constants";
import { DYNAMICFORMS } from "utils/dynamicForms";
import {  findValueByKey, trans } from "utils/helpers";
import './style.scss';


interface props {
    formList: any,
    Id: string,
    onHide: () => void,
    reload?: (e) => void,
    formCallBack?: (e) => void,
    styleCondition?: any
    jobId?: any
    taskTitle?: any
    inDynamicForms?: any;

    sourceId?: string,
    RequesterPositionId?: any
    SourceData?: any;
    closeForm?: () => void,
    JobNo?: any
    disable?:boolean;



}
export const passListContext = createContext<any>([]);

export const ModalFormList: React.FC<props> = ({disable, JobNo,formCallBack, closeForm, SourceData, RequesterPositionId,  sourceId,inDynamicForms=false, formList, taskTitle ,styleCondition = false, Id, onHide, reload ,jobId }) => {

    const [progress, setProgress] = useState<number>(0);
    const [counter, setCounter] = useState<any>(0);
    const [pass, setPass] = useState<any>();
    const [passList, setPassList] = useState<any>([]);
    const [showstep, setShowstep] = useState<any>({});

    function addNewPass(e){
        if(!passList.includes(e)){
            setPassList([...passList , e])
        }
    }
    //const [references, setReferences] = useState<any>([]);
    function circleClick(e) {
        let complete = formList.length - 1
        setProgress((100 / complete) * e)
        setCounter(e)
    }



    function next() {
        let complete = formList.length - 1;
        setProgress(progress + (100 / complete))
        setCounter(counter + 1)




    }

    function prev() {
        let complete = formList.length - 1;
        setProgress(progress - (100 / complete))
        setCounter(counter - 1)

    }



    useEffect(() => {

        const formListReverc = JSON.parse(JSON.stringify(formList)) 
        let Tindex:any
        formListReverc.reverse().forEach((item, index) => {
            if (item.Parameters && item.Parameters != "") {
                let paramsObject: ComponentParams = JSON.parse(item.Parameters.toLowerCase());
                let mode = findValueByKey(paramsObject, "mode");
                if (mode != "view") {
                    Tindex = index
                }
            }
        });
        if(Tindex != undefined){
            Tindex = Math.abs((formList.length-1)-Tindex ) 
            let complete = formList.length - 1
            setProgress((100 / complete) * Tindex)
            setCounter(Tindex)
            setPass(Tindex)

        }else{
            Tindex = Math.abs(formList.length ) 
            setProgress(100 )
            setCounter(Tindex-1)
            setPass(Tindex)


        }
    }, [formList])




    return (
        <passListContext.Provider value={[passList, addNewPass]}>
        <div className="card mb-0">
            {formList.length > 1 ?
                <div className={`${styleCondition ? 'referencewizard-b' : 'referencewizard'}`}>
                 
                    <div className="content-card d-flex flex-column w-100">
                        <div className="content-card d-flex flex-column w-100">
                            
                                {formList.map((item , formIndex)=>(
                                    <div className="card" key={formIndex}>
                                        <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px" , justifyContent:"space-between" }} className="d-flex  py-1 col-12 pr-4"> 
                                        <div>{trans(item.Name)}</div>      
                                        <div  style={{marginLeft:"18px"}}onClick={()=>{showstep[formIndex]?setShowstep({...showstep , [formIndex]:false}):setShowstep({...showstep , [formIndex]:true}) }}  >{showstep[formIndex] ? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" />:<FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                                        </div>
                                        <div style={{display: !showstep[formIndex] ?"block" :"none"}} className="card-body">
                                    <DynamicComponentHOC parentISCartable={true} formCallBack={formCallBack} JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  sourceId={sourceId} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                                    componentName={DYNAMICFORMS[formList[formIndex].Name] ?null:formList[formIndex].Name} component={DYNAMICFORMS[formList[formIndex].Name] ?DYNAMICFORMS[formList[formIndex].Name].component:null}
                                        reload={reload}  Name={formList[formIndex].Name}  componentParams={formList[formIndex].Parameters} processId={formList[formIndex].ProjectId} TaskId={formList[formIndex].TaskId}
                                        referenceId={Id} jobId={jobId} handleCancelForm={() => onHide()}  />
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
                :
                <>
                    {formList && formList[0] ?
                        <div className="">
                            <DynamicComponentHOC parentISCartable={true} formCallBack={formCallBack} JobNo={JobNo} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  sourceId={sourceId} inDynamicForms={inDynamicForms} taskTitle={taskTitle} onHide={onHide} 
                            componentName={DYNAMICFORMS[formList[0].Name] ?null:formList[0].Name} component={DYNAMICFORMS[formList[0].Name] ?DYNAMICFORMS[formList[0].Name].component:null}
                                reload={reload}  Name={formList[0].Name}  componentParams={formList[0].Parameters} processId={formList[0].ProjectId} TaskId={formList[0].TaskId}
                                referenceId={Id} jobId={jobId} handleCancelForm={() => onHide()}  />
                        </div>
                        :
                        <Message message={"NoDataForPreview"} type={"info"} />

                    }
                </>


            }



        </div>
        </passListContext.Provider>

    )
}